import { render, staticRenderFns } from "./ImmigrationView.vue?vue&type=template&id=778751b4&scoped=true"
import script from "./ImmigrationView.vue?vue&type=script&lang=js"
export * from "./ImmigrationView.vue?vue&type=script&lang=js"
import style0 from "./ImmigrationView.vue?vue&type=style&index=0&id=778751b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778751b4",
  null
  
)

export default component.exports